// removed by extract-text-webpack-plugin
module.exports = {"mark-picker":"mark-picker__mark-picker","mark-picker-any":"mark-picker__mark-picker-any"};


//////////////////
// WEBPACK FOOTER
// ./src/components/encoding-pane/mark-picker.scss
// module id = 1219
// module chunks = 0